import { MEMBER_REQUEST_SET, MEMBER_REQUEST_REMOVE } from '../../actions/member-request/types';

const emptyState = {};

export default function memberRequest(state = emptyState, { type, data }) {
  switch (type) {
    case MEMBER_REQUEST_SET:
      return {
        ...emptyState,
        ...data,
      };
    case MEMBER_REQUEST_REMOVE:
      return emptyState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/member-request/index.js